/**
 * Get CurrencySymbol from order
 * @param {object} order - order object
 * @return {string} currencySymbol
 */
export function getCurrencySymbol(order) {
    return order.__currencySymbol || order.currencySymbol;
}
